module.exports = __webpack_public_path__ + "static/media/date-range-arrow-right.0462f12e.svg";